import { resourceCategorys, resourceClassNameList } from '@/api/serach'

const user = {
  state: {
    categoryList: [],
    classNamesList: []
  },
  mutations: {
    SET_CATEGORY_LIST: (state, data) => {
      state.categoryList = data
    },
    SET_CLASSNAMES_LIST: (state, data) => {
      state.classNamesList = data
    }
  },
  actions: {
    getCategoryList ({ commit }) {
      return new Promise((resolve, reject) => {
        resourceCategorys().then(res => {
          const data = res.data || []
          commit('SET_CATEGORY_LIST', data)
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getClassNamesList ({ commit }) {
      return new Promise((resolve, reject) => {
        resourceClassNameList().then(res => {
          // const data = res.data.filter(v => v) || []
          const data = res.data
          commit('SET_CLASSNAMES_LIST', data)
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default user
